// translations/en/events.ts
export const eventsTranslations = {
    events: {
      pageTitle: "Events & Announcements",
      pageDescription: "Join our upcoming events, webinars, and community meetups to enhance your testing knowledge and connect with fellow professionals.",
      upcoming: "Upcoming",
      featured: "Featured",
      past: "Past Events",
      loading: "Loading events...",
      noUpcoming: "No upcoming events found.",
      noFeatured: "No featured events available.",
      noPast: "No past events available.",
      viewDetails: "View Details",
      register: "Register",
      registerUnavailable: "Register Unavailable",
      hostEvent: "Host an Event",
      viewCalendar: "View Calendar",
      shareTitle: "Share Your Knowledge with the Community",
      shareDescription: "Host your own webinar, workshop, or in-person meetup and contribute to the growth of the Quality Nexus community.",
      becomeHost: "Become an Event Host",
      attending: "attending",
      showingEvents: "Showing events",
      noTitle: "Untitled Event",
      noDescription: "No description available.",
      showing: "Showing",
      of: "of",
      viewAll: "View All Events"
    }
  };